package com.milta.feature.route.domain.usecase

import com.milta.feature.route.domain.repository.RouteRepository

/** POST /api/v1/routes/{id}/regeocode (MIL-45). */
class RegeocodeRouteUseCase(private val repository: RouteRepository) {
    suspend operator fun invoke(routeId: String) = repository.regeocodeRoute(routeId)
}
